import { useState } from "react";
import "./index.scss";
import Table from "react-bootstrap/Table";

export const Accordion = (props) => {
  const { title, children, is_data_array } = props;
  const [isOpen, setOpen] = useState(false);
  if (is_data_array) {
    return children;
  }
  return <>{title}</>;
  return (
    <div className="accordion-wrapper">
      <div
        className={`accordion-title ${isOpen ? "open" : ""}`}
        onClick={() => setOpen(!isOpen)}
      >
        {title}
      </div>
      <div className={`accordion-item ${!isOpen ? "collapsed" : ""}`}>
        <div className="accordion-content d-flex flex-column">{children}</div>
      </div>
    </div>
  );
};
